<template>
  <BaseGlobalLoader v-if="showGlobalLoader"/>
  <router-view :key="company" v-else/>
  <component :is="'script'" :src="MEET_BASE_API_URL" async></component>
</template>


<script setup>
import 'nprogress/nprogress.css'
import '../public/assets/css/nprogress.custom.css'
import BaseGlobalLoader from '@/components/BaseGlobalLoader'
import {computed, ref, watch} from 'vue';
import {useStore} from "vuex";
import { useRoute } from 'vue-router';
import {MEET_BASE_API_URL} from "@/services/meetService";

const store = useStore()
const isLoaded = computed(()=> store.getters['isAppLoaded'])
const company = computed(() => store.getters['offices/getSelectCompanyId'])

const route = useRoute();

// Ratchet à sens unique : isLoaded est togglé à chaque navigation (cf.
// router.beforeEach/afterEach dans router/index.js, pour la barre NProgress),
// pas seulement au tout premier chargement. Sans ce garde-fou, l'écran de
// chargement plein écran (BaseGlobalLoader) remplacerait <router-view> - donc
// tout le layout, header et sidebar compris - à chaque clic sur un onglet.
//
// isAppLoaded démarre à `false` par défaut dans le store (avant même le début
// du premier chargement) : on ne peut donc pas se contenter d'attendre qu'il
// "devienne" false, sinon le ratchet se déclenche instantanément au montage
// et le loader ne s'affiche plus jamais, même au vrai premier chargement. On
// exige une vraie transition true → false (un cycle de chargement réellement
// observé) avant de verrouiller le ratchet.
const hasBooted = ref(false)
let sawLoading = false
watch(isLoaded, (val) => {
  if (val) {
    sawLoading = true
  } else if (sawLoading) {
    hasBooted.value = true
  }
})

const showGlobalLoader = computed(() => isLoaded.value && !hasBooted.value)
</script>
<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-y {
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}


</style>
